import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import ProductionProcessMobile from "./ProductionProcessMobile";
import ProductionProcess from "./ProductionProcess";

export default function ResponsiveProductionProcess(props) {
  return useIsMobile() && !props.restaurantMode
    ? <ProductionProcessMobile {...props} />
    : <ProductionProcess {...props} />;
}
